import api, { apiGateway, EfArray } from '@config/api';
import axios from 'axios';
import { domainsForTrainings, ipacFormationsCBtoDisplay } from '@config/lists';
import { formConfig } from '@config/formConfig';
import { defaultConsentPhrases } from '@config/forms';
import { isIpac } from '@config/constants';

//! Disclaimer, certaines méthodes ne servent plus et seront supprimées dans le pruning
/**
 * @returns {Promise<training[]>}
 */
export const getTrainings = async () => {
  try {
    const response = await axios.get(api.trainings, {
      headers: {
        Accept: 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error; // Re-throw the error to propagate it to the caller
  }
};

/**
 * @description Retourne les formations et leur position pour une thématique donnée
 * @returns {Promise<training[]>}
 */
export const getTrainingsByDomain = async (domainId) => {
  try {
    // recupération de l'array et filtre dessus
    const response = await axios.get(
      `${EfArray.url}?getting=${EfArray.getting}&token=${EfArray.token}`,
      {
        headers: {
          Accept: 'application/json',
        },
      }
    );

    // Transformer l'ARRAY en array d'objets mieux rangés (ex pouvoir correcterment boucler dessus et passer leur titre en Id plutôt que comme index)
    const arrayOfObjects = Object.values(response.data).map(
      (innerObj, index) => {
        return {
          id: Object.keys(response.data)[index],
          ...innerObj,
        };
      }
    );

    // Filter l'array d'objet en conservant uniquement ceux qui appartiennent à la thématique en argument id
    const filteredObjectsDomainOnly = arrayOfObjects.filter((entry) => {
      const idFormationBitrix = entry.ID_FORMATION_BITRIX;
      return (
        domainsForTrainings[idFormationBitrix] &&
        domainsForTrainings[idFormationBitrix].domains.includes(
          Number(domainId)
        )
      );
    });

    // on boucle uniquement sur les formations de la thématique séléctionnée
    // retourne la/les formation(s) et leur position
    return filteredObjectsDomainOnly.map((course) => {
      const idFormationBitrix = course.ID_FORMATION_BITRIX;

      // recupère la position du domainId dans la liste.
      // Ex:[4,8]. retourne 2 si notre domain selectionné est le 8
      let positionIndex = domainsForTrainings[
        idFormationBitrix
      ].domains.indexOf(Number(domainId));

      // récupère la position de la formation pour le domain séléctionné
      let position =
        domainsForTrainings[idFormationBitrix].positions[positionIndex];
      return {
        ...course,
        position,
      };
    });
  } catch (error) {
    console.error(error);
    throw error; // Re-throw the error to propagate it to the caller
  }
};

/**
 *
 * @param {int} id
 * @returns training
 */
export const getTraining = async (id) => {
  /* istanbul ignore next */
  try {
    const result = await axios.get(
      `${apiGateway.path}${apiGateway.endpoint.formation.byId}${id}`,
      {
        headers: {
          Accept: 'application/json',
        },
      }
    );
    return result?.data;
  } catch (e) {
    console.error(e);
  }

};

/**
 *
 * @param {object} data - form data
 * @returns
 */
export const getToken = (data) => {
  /* istanbul ignore next */
  try {
    return axios
      .post(`${api.path}?token-request=1`, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((response) => {
        return new Promise((resolve, reject) => {
          try {
            resolve(response.data);
          } catch (err) {
            reject(err);
          }
        });
      })
      .catch(function (error) {
        reject(error);
      });
  } catch (e) {
    console.error(e);
  }
};

/**
 *
 * @param {object} data
 * @param {string} token
 * @returns
 */
export const save = (data, token) => {
  /* istanbul ignore next */
  try {
    return axios
      .post(`${api.path}`, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return new Promise((resolve, reject) => {
          try {
            resolve(response);
          } catch (err) {
            reject(err);
          }
        });
      })
      .catch(function (error) {
        return new Promise((resolve, reject) => {
          try {
            reject(error);
          } catch (err) {
            reject(err);
          }
        });
      });
  } catch (e) {
    console.error(e);
  }
};

export const getConsentPhrases = async () => {
  try {
    const result = await axios.get(
      `${apiGateway.path}${apiGateway.endpoint.consents.phrases}formLead`,
      {},
      {
        headers: { 'Access-Control-Allow-Origin': '*' },
      }
    );
    return result?.data;
  } catch (e) {
    console.error(e);
  }

  return defaultConsentPhrases;
};

export const toLocalStorage = (fields) => {
  if (Object.entries(fields).length) {
    Object.entries(fields).map((field) => {
      if (!['consentContact', 'consentPartners'].includes(field[0])) {
        setStorageItem(field[0], field[1]);
      }
    });
  }
};

/**
 * function pour cleaner un peu le localstorage
 *
 * à utiliser idéalement au début sur la page intro
 * et à la fin d'un submit sur une page multi
 */
export const cleanStorage = () => {
  try {
    const defaultForm = formConfig.form;
    localStorage.removeItem('localState');
    localStorage.removeItem('domainId');
    localStorage.removeItem('trainingId');
    localStorage.removeItem('idFormationBitrix');
    localStorage.removeItem('trainingName');
    localStorage.removeItem('etudes');
    localStorage.removeItem('dateOfBirth');
    for (const question of defaultForm) {
      const { key } = question;
      localStorage.removeItem(key);
    }
  } catch (error) {
    console.error(
      'Valeur de localState invalide ou corrompue dans le localStorage. Videz le localStorage.',
      error
    );
  }
};
/**
 * finalement cette fonction reset le loclastorage en retourne un localstorage vide au context au premier chargement
 * @returns
 */
export const validateOrResetLocalStorageOnIntroPage = () => {
  try {
    cleanStorage();
    return null;
  } catch (error) {
    console.error(
      'Valeur de localState invalide ou corrompue dans le localStorage. Videz le localStorage.'
    );
  }

  // rien n'a changé
  return null;
};

const setStorageItem = (key, value) => {
  const now = new Date();
  localStorage.setItem(
    key,
    JSON.stringify({
      value,
      expiry: now.getTime() + 432000, //5j
    })
  );
};

export const fromLocalStorage = (fields) => {
  let fieldStored = fields;
  if (Object.entries(fields).length) {
    Object.entries(fields).map((field) => {
      const fieldName = field[0];
      let itemStr = localStorage.getItem(fieldName);
      if (itemStr) {
        if (!isJson(itemStr)) {
          setStorageItem(fieldName, itemStr);
          itemStr = localStorage.getItem(fieldName);
        }
        const item = JSON.parse(itemStr);
        itemStr = item.value;
        fieldStored[fieldName] = itemStr;
      }
    });
  }
  return fieldStored;
};

const isJson = (item) => {
  item = typeof item !== 'string' ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  return typeof item === 'object' && item !== null;


};

// Désormais le switchForm pourra être configuré dans WP et par défaut renverra sur /formulaire-test/
/**
 * function to return the new url toward which
 * user should be redirected after filling introPageFrom
 * the url should contain the main form + query params of pre-filled form data
 *
 * The pre-filled data will be the mixt of data provided by :
 *   WP shortcode (public/config.js for dev) (domainId or traindId)
 *   Data selected in the intro_page form by user
 *   Or data provided in Url searchParams
 *
 * short_code data > user selected Data > url search data
 *
 * @param {string} originalUrl
 * @returns {string} newUrl
 */
export const switchFormV2 = (originalUrl) => {
  const baseUrl = window.location.origin;
  const url = new URL(originalUrl);
  //check si on a renseigné un mainFormUrl (URL du formulaire principal) dans le fichier config WP
  const mainFormFromConfig = global.window.Config?.mainFormUrl;

  const newUrl = mainFormFromConfig
    ? new URL(`${baseUrl}${mainFormFromConfig}`)
    : new URL(`${baseUrl}/formulaire-test/`);
  //On conserve les queryParams (ex UTM etc...)
  newUrl.search = url.search;
  const parsedValues = getKnownFormValues();

  for (const [key, value] of Object.entries(parsedValues)) {
    //this can be improved again by checking duplicate query params
    newUrl.searchParams.append(key, value);
  }

  return newUrl.href;
};

//hold the equivalence of keys
// domainId injected by short_code and localstorage is domain in formConfig an url
// use this before a global refactor of codebase
const FORM_KEY_CONFIG_EQUIVALENCE = {
  domain: 'domainId',
  training: 'trainingId',
};

/**
 * this function return an array of the list of known values
 * in the current form
 *
 * Known values are values either provided by the WP shortcode
 * the User choice
 * or the Url query params
 *
 * short_code data > user selected Data > url search data
 *
 * @returns object {[key]: value}
 */
const getKnownFormValues = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const defaultForm = formConfig.form;
  //keep in mind that for now sometime the data can be saved in localstorage directly, and not under the localstate key
  const localState = JSON.parse(localStorage.getItem('localState'));

  const parsedValues = {};

  for (const question of defaultForm) {
    const { key } = question;

    const urlParamValue = searchParams.get(key);
    //if key = domain , finalKey will be domainId
    const keyToSearch = FORM_KEY_CONFIG_EQUIVALENCE[key] ?? key;

    const configValue = global.window.Config?.efArray?.[keyToSearch];
    let localStorageValue =
      JSON.parse(localStorage.getItem(keyToSearch))?.value ??
      localState?.formDataContext[keyToSearch];
    if (key === 'training') {
      localStorageValue = localState?.formDataContext['idFormationBitrix'];
    }

    //get short_code data or user selected Data (localstorage) or url search data
    if (configValue !== undefined && configValue !== 0) {
      parsedValues[key] = configValue;
    } else if (localStorageValue !== undefined) {
      parsedValues[key] = localStorageValue;
    } else if (urlParamValue) {
      parsedValues[key] = urlParamValue;
    }
  }

  return parsedValues;
};

export const getMetaEventIdFromStorage = () => {
  try {
    const localState = JSON.parse(localStorage.getItem('localState'));

    return localState?.formDataContext['metaEventId'];
  } catch (error) {
    console.error('error while retrieving localstorage metaEventId');
  }
  return null;
};

/**
 * returns form values extracted from either URL , window.Config or default formConfig
 *
 * it returns a key value object
 * @returns Array[{key, value}]
 */
export const getFormValues = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const defaultForm = formConfig.form;

  const parsedValues = [];

  for (const question of defaultForm) {
    const { key } = question;

    const urlParamValue = searchParams.get(key);
    //if key = domain , finalKey will be domainId
    const keyToSearch = FORM_KEY_CONFIG_EQUIVALENCE[key] ?? key;

    const configValue = global.window.Config?.efArray?.[keyToSearch];
    const defaultConfigValue = formConfig?.efArray?.[keyToSearch];

    if (urlParamValue) {
      parsedValues.push({ key, value: Number(urlParamValue) });
    } else if (configValue) {
      parsedValues.push({ key, value: configValue });
    } else if (defaultConfigValue) {
      parsedValues.push({ key, value: defaultConfigValue });
    }
  }

  const etape =
    searchParams.get('etape') ??
    global.window?.Config?.entryStep ??
    formConfig.entryStep ??
    null;
  if (etape) {
    parsedValues.push({ key: 'etape', value: etape });
  }
  //Todo save those value in localStorage or in formContext
  return parsedValues;
};

export const retrieveAndSetUTM = (handleFormData) => {
  if (localStorage.getItem('b24_crm_guest_utm')) {
    const utmRefs = JSON.parse(localStorage?.getItem('b24_crm_guest_ref'))?.ref;
    const localUTMs = new Map(
      Object.entries(JSON.parse(localStorage.getItem('b24_crm_guest_utm')).list)
    );
    if (localUTMs['utm_source'] === 'manuel') {
      resetFormData();
    }
    [...localUTMs].map(([name, value]) => {
      let data = { name: name, value: value };
      data?.name && data?.value && handleFormData(data);
    });
  }
};

// FILTRER LES FORMATIONS POUR AVOIR TROIS GROUPES : DIPLOMANTES, CERTIFIANTES ET ACCELEREES
export const filterTrainings = (trainings) => {
  // Les formations diplomantes durent forcément plus de 8 mois et possèdent au moins une thématique
  const diplomantes = trainings.filter(
    (training) =>
      training.PERIODE >= 8 &&
      Object.values(
        domainsForTrainings[training?.ID_FORMATION_BITRIX]?.domains
      ).some((value) => value)
  );

  // Les formations accélérées n'ont pas de CPF donc pas de valeur dans la propriété FOAD et possèdent au moins une thématique
  const accelerees = isIpac
    ? trainings.filter((training) => {
        return ipacFormationsCBtoDisplay.includes(training.ID_FORMATION_BITRIX);
      })
    : trainings.filter((training) => {
        return (
          Object.values(training.FOAD).every((value) => !value) &&
          Object.values(
            domainsForTrainings[training?.ID_FORMATION_BITRIX]?.domains
          ).some((value) => value)
        );
      });

  // Les formations certifiantes sont toutes les formations qui ne sont ni diplomantes ni accélérées
  // mais qui ont au moins une propriété FOAD et une thématique
  const certifiantes = trainings.filter(
    (training) =>
      Object.values(training.FOAD).some((value) => value) &&
      Object.values(
        domainsForTrainings[training?.ID_FORMATION_BITRIX]?.domains
      ).some((value) => value) &&
      !accelerees.includes(training) &&
      !diplomantes.includes(training)
  );

  return { certifiantes, diplomantes, accelerees };
};

// Comme la fonction d'en haut, sauf que c'est sur une seule formation (on veut savoir son type)
export const filterTraining = (training) => {
  if (
    training.PERIODE >= 8 &&
    Object.values(
      domainsForTrainings[training?.ID_FORMATION_BITRIX]?.domains
    ).some((value) => value)
  ) {
    return 'diplômante';
  }
  if (
    Object.values(training.FOAD).every((value) => !value) &&
    Object.values(
      domainsForTrainings[training?.ID_FORMATION_BITRIX]?.domains
    ).some((value) => value)
  ) {
    return 'accélérée';
  }
  if (
    Object.values(training.FOAD).some((value) => value) &&
    Object.values(
      domainsForTrainings[training?.ID_FORMATION_BITRIX]?.domains
    ).some((value) => value) &&
    training.PERIODE < 8
  ) {
    return 'certifiante';
  }
};

export const retrieveUTMInURL = () => {
  const queryParams = {};

  Object.keys(localStorage).forEach(key => {
    if (key.startsWith("utm_")) {
      try {
        const parsed = JSON.parse(localStorage.getItem(key));
        queryParams[key] = parsed && parsed.value ? parsed.value : "";
      } catch (e) {
        queryParams[key] = localStorage.getItem(key);
      }
    }
  });

  return new URLSearchParams(queryParams).toString();
};
